import { ConfigRepository } from '~repositories/ConfigRepository';
import { TranslationRepository } from '~repositories/TranslationRepository';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';
import { composeFieldsValidations, FieldValidations } from '~utils/FieldValidations';

export class GenerateFieldValidationsUseCase {
    private configRepository: ConfigRepository;
    private translationRepository: TranslationRepository;

    constructor() {
        this.configRepository = diContainer.get(serviceNames.configRepository);
        this.translationRepository = diContainer.get(serviceNames.translationRepository);
    }

    public execute = () => {
        const { formSchema, iamConfig, badCharValidation } = this.configRepository;
        const { translations } = this.translationRepository;

        let fieldsValidations: Record<string, FieldValidations> = {};
        if (formSchema && iamConfig) {
            fieldsValidations = composeFieldsValidations(
                formSchema,
                iamConfig.fieldsValidations,
                translations,
                badCharValidation
            );
        }

        this.configRepository.setFieldsValidations(fieldsValidations);
    };
}
